// Generated by ReScript, PLEASE EDIT WITH CARE

import * as IconBinding$Catalyst from "./IconBinding.bs.js";
import Call from "@material-ui/icons/Call";
import Close from "@material-ui/icons/Close";
import Launch from "@material-ui/icons/Launch";
import Person from "@material-ui/icons/Person";
import Replay from "@material-ui/icons/Replay";
import MoreVert from "@material-ui/icons/MoreVert";
import ArrowBack from "@material-ui/icons/ArrowBack";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Visibility from "@material-ui/icons/Visibility";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import EditOutlined from "@material-ui/icons/EditOutlined";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import AccountCircle from "@material-ui/icons/AccountCircle";
import CalendarToday from "@material-ui/icons/CalendarToday";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import NotificationsNone from "@material-ui/icons/NotificationsNone";
import NavigateNextRounded from "@material-ui/icons/NavigateNextRounded";
import ReportProblemOutlined from "@material-ui/icons/ReportProblemOutlined";

var ExpandMoreIcon = IconBinding$Catalyst.Make({
      reactClass: ExpandMore
    });

var ExpandLessIcon = IconBinding$Catalyst.Make({
      reactClass: ExpandLess
    });

var CloseIcon = IconBinding$Catalyst.Make({
      reactClass: Close
    });

var NavigateIcon = IconBinding$Catalyst.Make({
      reactClass: Launch
    });

var WarningIcon = IconBinding$Catalyst.Make({
      reactClass: ReportProblemOutlined
    });

var PersonIcon = IconBinding$Catalyst.Make({
      reactClass: Person
    });

var EditIcon = IconBinding$Catalyst.Make({
      reactClass: EditOutlined
    });

var MoreVertIcon = IconBinding$Catalyst.Make({
      reactClass: MoreVert
    });

var NavigateNextRoundedIcon = IconBinding$Catalyst.Make({
      reactClass: NavigateNextRounded
    });

var KeyboardArrowUpIconIcon = IconBinding$Catalyst.Make({
      reactClass: KeyboardArrowUp
    });

var KeyboardArrowDownIconIcon = IconBinding$Catalyst.Make({
      reactClass: KeyboardArrowDown
    });

var ArrowBackIcon = IconBinding$Catalyst.Make({
      reactClass: ArrowBackIos
    });

var AccountIcon = IconBinding$Catalyst.Make({
      reactClass: AccountCircle
    });

var VisibilityIcon = IconBinding$Catalyst.Make({
      reactClass: Visibility
    });

var VisibilityOffIcon = IconBinding$Catalyst.Make({
      reactClass: VisibilityOff
    });

var CallIcon = IconBinding$Catalyst.Make({
      reactClass: Call
    });

var RetryIcon = IconBinding$Catalyst.Make({
      reactClass: Replay
    });

var BellIcon = IconBinding$Catalyst.Make({
      reactClass: NotificationsNone
    });

var InfoIcon = IconBinding$Catalyst.Make({
      reactClass: InfoOutlined
    });

var CalendarIcon = IconBinding$Catalyst.Make({
      reactClass: CalendarToday
    });

var BackArrowIcon = IconBinding$Catalyst.Make({
      reactClass: ArrowBack
    });

export {
  ExpandMoreIcon ,
  ExpandLessIcon ,
  CloseIcon ,
  NavigateIcon ,
  WarningIcon ,
  PersonIcon ,
  EditIcon ,
  MoreVertIcon ,
  NavigateNextRoundedIcon ,
  KeyboardArrowUpIconIcon ,
  KeyboardArrowDownIconIcon ,
  ArrowBackIcon ,
  AccountIcon ,
  VisibilityIcon ,
  VisibilityOffIcon ,
  CallIcon ,
  RetryIcon ,
  BellIcon ,
  InfoIcon ,
  CalendarIcon ,
  BackArrowIcon ,
  
}
/* ExpandMoreIcon Not a pure module */
